import { IProgress } from "@skbkontur/extern-core-js/dist/cjs/src/common/progress";
import { CancellationToken } from "@skbkontur/extern-core-js/dist/cjs/src/utils";
import { IDriveContentUploadResult } from "@skbkontur/extern-core-js/dist/cjs/src/drive/shared";
import { DriveSettingsFactory } from "@skbkontur/extern-core-js/dist/cjs/src/drive/settingsFactory";
import { NativeDrive1Client } from "@skbkontur/extern-core-js/dist/cjs/src/drive/drive1client";

import { isTestEnvironment } from "../../Engine/utils";
import { CustomFile } from "../file";

interface DriveExternTaskParams {
    file: CustomFile;
    progress?: IProgress;
    cancellationToken?: CancellationToken;
}

type DriveExternTask = (params: DriveExternTaskParams) => Promise<IDriveContentUploadResult>;

interface UploadWithExternDriveClient {
    onProgress?: (done: number, total: number) => void;
    getPortalUserId: () => Promise<string>;
}

export async function uploadWithExternDriveClient({
    getPortalUserId,
}: UploadWithExternDriveClient): Promise<DriveExternTask> {
    let nativeDrive1Client: NativeDrive1Client;

    const initDrive = new Promise<void>((resolve, reject) => {
        const settings = isTestEnvironment()
            ? DriveSettingsFactory.getForDrive1Test()
            : DriveSettingsFactory.getForDrive1();

        getPortalUserId().then(portalUserId => {
            nativeDrive1Client = new NativeDrive1Client(settings, portalUserId);
            resolve();
        }, reject);
    });

    await initDrive;

    return ({ file, progress, cancellationToken }) => {
        if (nativeDrive1Client === undefined) {
            throw new Error("Drive client is not loaded");
        }

        // @ts-ignore
        return nativeDrive1Client.upload(file, { daysToLive: 30, srv: "candyFront" }, cancellationToken, progress);
    };
}
